export default __webpack_public_path__ + "static/media/kemi.69e6c04d.png";